var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialsCoverIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 227,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 255 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.1,
    cy: 139.3,
    r: 87.7,
    fill: "#151E44"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 255,
    height: 227,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M176 139.3a87.7 87.7 0 1 1-175.4 0C-1.4 84-7-19.2 161.9 3.1c53 7 171.8 39.8 14 136.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B28B67",
    fillRule: "evenodd",
    d: "M146.4 130.7c-3.7 3.7-7.6 6-9.8 6-5.4 0-10.5-18.3-8.4-26.5 2-8.2 21.4-16.5 26-2.3 1.6 4.9.6 9.8-1.5 14.3l12 24.4-16.1 4.1-2.2-20z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M135.3 99.5c2-.9 7.7-2.6 8.8-2.8.7-.2 1.5-.2 1.7-1 .2-.5-.1-1.4-.2-2a28.9 28.9 0 0 1 .7-8.1c1-3.7 3.1-6.9 6.2-9.2 3.3-2.6 7.5-4 11.6-4.7 4.5-.8 8.8-.3 13.2 0 4.2.3 8.4-.3 12.4-2 4-1.6 6.5-4.6 9.4-7.6 3-3 6.7-5.5 11-6.2 4-.7 8 0 11.8 1.4a18 18 0 0 1 9 6c2.4 3.4 3.4 7.4 1.7 11.3-2.4 5.6-8.8 8.5-14.5 9.8-3.2.7-6.6 1-9.9.6-4.4-.4-8.5-1.9-12.9-2.9-2-.5-4-.8-6-.8-2.1 0-4 .2-5.4 1.7-1.5 1.7-2.9 3.3-4.7 4.5a18.3 18.3 0 0 1-6 2.7c-4 1-8.4.7-12.6.9-3.4.1-7 .3-10.2 1.8-1.3.6-3.2 1.7-3.3 3.3 8.8-.6 14.7 8.9 14.2 17-.2 4.5-6.7 11.2-10.2 9.8-2.3-.8-1.6-3-1.1-4.3.8-2.6.6-5.7-2.5-6.6-2.6-.8-4.1 3-4.2 3-.6.2-6.8-1.5-11.6-5-3.6 1.1-4.8-1.1-4.4-3.3.4-2.2 5.2-6 8-7.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B28B67",
    fillRule: "evenodd",
    d: "M191.4 202c1 17.2-73 77-73.2 78.5-.2 1 32.3 55.8 32.3 55.8l-6.7 3.6s-46.4-56.5-45.2-63.3c1.6-9.8 54.4-69.5 54.4-69.5l38.4-5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F3676",
    fillRule: "evenodd",
    d: "m147.6 327.8-11 5.6c-27.5-24.1-39.7-45.3-39.4-57 .2-11.5 54.2-69.2 54.2-69.2l40.9-5.2c3.5 39.4-67.1 77.8-68 79.6-.7 1.8 11.1 17 23.3 46.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#997659",
    fillRule: "evenodd",
    d: "m182.2 203.2 46.5 81 44.1 67.8-8.3 1-110.3-146.2 28-3.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C63AB",
    fillRule: "evenodd",
    d: "m267.8 337.4-18 5.8c-16.8-19.1-87-97-98.6-136l41-5.2c25.3 26 59.3 116 75.6 135.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B28B67",
    fillRule: "evenodd",
    d: "m90.4 193.8 27.2 4.5-5.3 12-21.9-9.4c-9.5.6-14.1.2-13.8-1.1.4-1.2 1.4-1.5 2.3-1.8.8-.2 1.4-.5 1.7-1 .6-1.4-2.4-4.2-5.4-6.9-3-2.6-.9-3 .4-2.9 4.5 1.2 9.5 3.4 14.8 6.6zM204 182.5l13.2-6.2a363.8 363.8 0 0 0 27 36.3c1.7 1.4 11 3.8 17 4.8 2.5.4 2.5 2.4 2 3.1-3.1 4.8-7.3 4.5-11.8 4l-4-.2c-3.5 0-4 2-4.6 3.8-.5 1.7-1 3.2-3.4 3.2v-1.6c0-3.7 0-9.2-2.7-11.7-1.4-1.3-12.3-13.1-32.7-35.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "evenodd",
    d: "m152.7 137.8-6 .4c-9.7 15.5-7.4 46.3-14.9 52.4-7 5.7-19.3 5-34 3.5L96 204.4c15.6 10.1 44.5 14.7 53.4 5.6 14.4-14.4 9.1-51.8 3.3-72.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "evenodd",
    d: "m196.5 204.4-51.5 13c-2.4.6-2.8-3-3-4.7-1-20.8 9-46 2-74l14.2-6.1c17.3 16.6 27.7 39.8 38.3 71.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "m165.1 227.3 46.4-11.7c-3.5-10.9-8.8-22-14.9-32.5a269 269 0 0 0 36.8 34.1l10.3-4.8c-17.8-41.3-46-68-84.5-80h-.2l-5.7 1.4s-2.9 73.1 11.8 93.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.8,
    height: 24.3,
    x: 78.5,
    y: 146.5,
    fill: "#000",
    rx: 4,
    transform: "rotate(-54 78.5 146.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.1,
    height: 20.5,
    x: 81.6,
    y: 145.7,
    fill: "#B8B8B8",
    rx: 4,
    transform: "rotate(-54 81.6 145.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 14.5,
    x: 98.6,
    y: 130.5,
    fill: "#fff",
    rx: 1.7,
    transform: "rotate(-54 98.6 130.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 95.9,
    y: 128.5,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(-54 95.9 128.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 14.5,
    x: 94.7,
    y: 135.2,
    fill: "#fff",
    rx: 1.7,
    transform: "rotate(-54 94.7 135.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 92,
    y: 133.1,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(-54 92 133.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 14.5,
    x: 91.6,
    y: 139.9,
    fill: "#fff",
    rx: 1.7,
    transform: "rotate(-54 91.6 139.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 88.9,
    y: 137.8,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(-54 88.9 137.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 14.5,
    x: 88.5,
    y: 144.6,
    fill: "#fff",
    rx: 1.7,
    transform: "rotate(-54 88.5 144.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 85.7,
    y: 142.5,
    fill: "#fff",
    rx: 1.6,
    transform: "rotate(-54 85.7 142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B28B67",
    fillRule: "evenodd",
    d: "M32.5 91.1c3.9 4.2 8 6.8 10.3 6.9 5.8.1 12-19.3 10-28.3-2-8.9-22.4-18.4-27.9-3.4-1.9 5.3-1 10.6 1.2 15.5l-13.8 25.8 17.3 5 3-21.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    fillRule: "evenodd",
    d: "M48.4 59.4a23.5 23.5 0 0 0-7-2.9c1.4-1.7 2.3-3.8 2.6-6 .4-2.1 0-4.1-.4-6.2a8 8 0 0 0-.8-2.8 5.3 5.3 0 0 0-2-2c-1-.5-1.9-.7-2.9-.8h-1.3c-.4 0-.5-.3-.7-.6a5.3 5.3 0 0 0-2.4-1.8 7.2 7.2 0 0 0-6.2.4c-.4.2-.7.5-1 1l-.4.2h-.6c-1.7 0-3.5.9-4.7 2.3-.7.8-1.4 2.4-1.9 4.3a20 20 0 0 0 1 9.4c.9 2 2.6 3.6 4.5 4.6a16.1 16.1 0 0 0-4.4 4.5 26.9 26.9 0 0 0-4.6 12.5c0 2 .4 3.8 1.8 5.3.6.7 1.3 1.2 2 1.8l2.3 1.5c1.5.7 3.3 1.2 4.9.3a9 9 0 0 0 1.7-1.2c.2-.2.3-.3.2-.5l-.5-.8c-1-1.4-1.3-3-1-4.7.3-1.8 1.3-3.8 3.2-4 2.3-.4 4.2 1.3 5.7 2.8 1.5-2.5 3.8-4.5 6.6-5 3.1-.6 6.3.2 9.4-.2.8-.1 1.6-.3 2.3-.7l.9-.8c.2-.4 0-.9 0-1.3-.7-2.2-4.2-7.2-6.3-8.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#997659",
    fillRule: "evenodd",
    d: "m-5.7 163.8 13.2 107 6.3 88.4 8.2 3.6 5.5-184.3-33.2-14.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "m8.3 343 18 2.3s3.3-35.5 4.7-79.4c1.4-43.8-.5-86-.5-86L-14.1 160s-.2 52.2 5.5 97.5 17 85.5 17 85.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B28B67",
    fillRule: "evenodd",
    d: "M-9 162.3c-18 27.6-44 61.4-45.5 62.2-.9.6-24.9-1.7-72-6.9l-1.4 8c52.3 14.8 80.6 20.8 85 18 6.6-4 47-41.5 67.3-66.5L-9 162.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4133",
    fillRule: "evenodd",
    d: "m-109.2 217.8-2 13c35.3 19.6 58.9 27.3 70.6 23 11.8-4.1 34.3-29.3 67.5-75.5l-42.5-18.9a1303.3 1303.3 0 0 1-40.2 60.2c-1.6 1.4-19.4.8-53.4-1.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#997659",
    fillRule: "evenodd",
    d: "m69 125.1-29 6.5 6.4 12.5 22.9-11.4c10.2.1 15.2-.5 14.7-2-.4-1.2-1.5-1.5-2.6-1.7-.8-.2-1.5-.4-1.8-1-.7-1.4 2.3-4.7 5.3-7.7s.8-3.3-.5-3.1a64 64 0 0 0-15.6 8zm19.5 26.3L76 154.2l-2.5 11.2s8.5-3.1 15.1-3c8.4 0 12-.7 17.2-4.5 2.8-2 6-6.7 4.5-9-.5-.8-3.7 0-7 .7-2.5.6-5 1.2-6.4 1-2 0-1-2.4-.4-4.2.5-1.3 1-2.4.2-2.2-3.3-1-8 7.2-8 7.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0AC18",
    fillRule: "evenodd",
    d: "M28.9 125.1c8.7 2.4 20.9 3.9 35.6-.4l1.7 12.2c-11 6-25 9.6-35.4 6.3-8.3-2.6-9.7-13.9-2-18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD3F",
    fillRule: "evenodd",
    d: "m35.3 97.2 2 .5c-2.4 11.7-2 25.1-1.8 38.7l.1 9.4c13.6 7.4 49 5.2 49 5.2s3.3 19 .7 26a116 116 0 0 1-52 .7 47 47 0 0 1-10.1 21c-7 7.9-24.2.4-39.1-6a82 82 0 0 0-20.1-7c-.4-18 6.8-27 13.4-35.5 4-5 7.8-9.9 9.6-16.2 5.2-18.4 28.2-42.6 30.4-42l.6.2 17.3 5z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialsCoverIllustration);
export default __webpack_public_path__ + "static/media/tutorials-cover-illustration.2341056596a1596b73fe576ddc2b5e32.svg";
export { ForwardRef as ReactComponent };